<template>
  <div style="overflow-x: auto">
    <div :style="!vertical ? 'min-width: 600px' : ''">
      <v-stepper
        v-if="data.length > 0"
        :value="currentstep"
        :alt-labels="!vertical"
        :non-linear="!vertical"
        class="mt-3 elevation-0"
        :vertical="vertical"
      >
        <v-stepper-header v-if="!vertical">
          <template v-for="(item, index) in data">
            <v-stepper-step
              :color="currentstep > index + 1 ? 'green' : 'primary'"
              :complete="currentstep > index + 1"
              :key="'statusData-' + index"
              :step="item.step"
            >
              <div class="text-center full-width">
                {{ item.title }}
              </div>
              <div v-if="item.subtitle" class="text-center full-width">
                <small>{{ item.subtitle }}</small>
              </div>
            </v-stepper-step>

            <v-divider
              v-if="index != data.length - 1"
              :key="'statusData2-' + index"
            ></v-divider>
          </template>
        </v-stepper-header>
        <template v-else v-for="(item, index) in data">
          <v-stepper-step
            :color="currentstep > index + 1 ? 'green' : 'primary'"
            :complete="currentstep > index + 1"
            :key="'statusData-' + index"
            :step="item.step"
          >
            <div>
              {{ item.title }}
            </div>
            <div v-if="item.subtitle" class="text-center full-width">
              <small>{{ item.subtitle }}</small>
            </div>
          </v-stepper-step>
          <v-stepper-content :step="item.step" :key="'statusContent-' + index">
          </v-stepper-content>
        </template>
      </v-stepper>
      <v-progress-circular
        v-else
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  // props: ['data', 'currentstep'],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    currentstep: {
      type: Number,
      default: 0
    }
  },
  // data() {
  //   return {
  //     updatekey: 0
  //   }
  // },
  computed: {
    vertical() {
      return this.$vuetify.breakpoint.xsOnly
    }
  }
}
</script>

<style>
@media only screen and (max-width: 959px) {
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: flex !important;
  }
}
</style>
